import { faCirclePlus } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IOrderFormSaveFn } from "order/model"
import { closeOrderFormPopup, openCreateOrderPopup } from "order/tools/form"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { OrderFormPopup } from "./OrderFormPopup"

interface IAddOrderPopupButtonProps {
  onSave: IOrderFormSaveFn
  disabled?: boolean
  isDspDeal?: boolean
  sxButton?: any
  sxPopup?: any
  id?: string
}

export const AddOrderPopupButton = React.memo(
  ({ sxButton, sxPopup, isDspDeal, disabled, id, onSave }: IAddOrderPopupButtonProps): JSX.Element => (
    <>
      <FlexBox
        jc="start"
        id={id}
        onClick={() => {
          if (disabled) {
            return
          }
          openCreateOrderPopup()
        }}
        sx={{
          "cursor": disabled ? undefined : "pointer",
          "height": "2.5rem",
          "& *": {
            transition: "color 400ms ease"
          },
          "&:hover *": {
            color: theme => (disabled ? theme.palette.action.disabled : theme.palette.form)
          },
          "& .plus-icon": {
            color: theme => (disabled ? theme.palette.action.disabled : theme.palette.primary.main),
            fontSize: ".75rem !important",
            fontWeight: "600 !important",
            cursor: disabled ? undefined : "pointer",
            mr: ".4rem"
          },
          ...sxButton
        }}>
        <FontAwesomeIcon icon={faCirclePlus} className="plus-icon" />
        <Typography
          sx={{
            fontWeight: "600 !important",
            color: theme => (disabled ? theme.palette.action.disabled : theme.palette.primary.main),
            fontSize: ".75rem !important"
          }}>
          {translate("order.add.button.title")}
        </Typography>
      </FlexBox>
      <OrderFormPopup
        id="form-add-order-popup-form"
        sx={sxPopup}
        isDspDeal={!!isDspDeal}
        onSave={result => {
          closeOrderFormPopup()
          onSave(result)
        }}
      />
    </>
  )
)
